<template>
  <div>
    <AppPageContainer custom="735px">
      <app-cells :indent="false" margin-bottom="18px">
        <div class="hm-subt">Details</div>
        <HMButton v-if="(isHotelReception || isGeneralManager || isHotelReservations) && !isEditDisabled" @click.native="onShowModalEditDetails">
          <PenIcon aria-hidden="true"/>
          <span>Edit</span>
        </HMButton>
      </app-cells>
      <HMDetail :r-data="rData"/>
      <HMInfo :r-data="rData"/>
      <app-cells :indent="false" margin-bottom="30px">
        <div class="hm-subt">Rooms Summary</div>
        <HMButton v-if="(isHotelReception || isGeneralManager || isHotelReservations) && !isEditDisabled" @click.native="isShowEditRooms = true">
          <PenIcon aria-hidden="true" />
          <span>Edit Rooms</span>
        </HMButton>
      </app-cells>
      <HMRoomSummary :meal-plan="rData.meal_plan" :rooms="rData.short_rooms"/>

      <app-cells :indent="false" margin-bottom="20px" margin-top="60px">
        <div class="hm-subt">Rooms</div>
      </app-cells>
      <HMRoomsList @update-rooms="fetchRooms" :loading="roomsLoading" :rooms="rooms" :guests-options="guests" :rData="rData" />
    </AppPageContainer>

    <app-cells :indent="false" margin-bottom="40px" margin-top="78px">
      <div class="hm-subt">Guests</div>
      <HMButton v-if="(isHotelReception || isGeneralManager || isHotelReservations) && !isEditDisabled" @click.native="onShowModalGuests(null)">
        <PlusIcon aria-hidden="true" />
        <span>Add Guests</span>
      </HMButton>
    </app-cells>
    <HMGuestsTable
      @edit="onShowModalGuests"
      @delete="onShowDeleteGuestModal"
      :guests="guests"
      :loading="guestsLoading"
    />
    <modal
      :adaptive="true"
      :clickToClose="false"
      :height="'auto'"
      :reset="true"
      :scrollable="true"
      :width="400"
      name="guest-delete"
    >
      <div class="popup-new">
        <button class="popup-new__close" type="button" @click="$modal.hide('guest-delete')"></button>
        <div class="popup-new__title">Delete Guest</div>
        <div class="popup-new__body">
          <div class="popup-new__subt">Are you sure you want to do that?</div>
          <app-cells position="center" :indent="false">
            <HMButton @click.native="$modal.hide('guest-delete')" background="#939393" color="#fff"><span>No</span></HMButton>
            <HMButton @click.native="onDeleteGuest" :loading="isDeletingGuest">
              <span>Yes</span>
            </HMButton>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      :adaptive="true"
      :clickToClose="false"
      :height="'auto'"
      :reset="true"
      :scrollable="true"
      :width="700"
      name="guest-form"
    >
      <div class="popup-new">
        <button class="popup-new__close" type="button" @click="$modal.hide('guest-form')"></button>
        <div class="popup-new__title">{{ guestToAction ? 'Edit' : 'Add' }} Guest</div>
        <div class="popup-new__body">
          <form @submit.prevent="onCheckForm('guestForm', 'onSaveGuests')">
            <app-grid>
              <template #item-1>
                <app-form-field :marginBottom="20" class="family" label="First Name" label-for="first_name" required>
                  <app-input
                    id="first_name"
                    v-model="guestForm.first_name"
                    :error="$v.guestForm.first_name.$error"
                    class="family"
                    placeholder="First Name"
                  />
                  <template #error>
                    <div v-if="$v.guestForm.first_name.$dirty && !$v.guestForm.first_name.required">Required
                      field
                    </div>
                  </template>
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Last Name" label-for="last_name" required>
                  <app-input
                    id="last_name"
                    v-model="guestForm.last_name"
                    :error="$v.guestForm.last_name.$error"
                    class="family"
                    placeholder="Last Name"
                  />
                  <template #error>
                    <div v-if="$v.guestForm.last_name.$dirty && !$v.guestForm.last_name.required">Required
                      field
                    </div>
                  </template>
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Gender">
                  <app-cells :indent="false">
                    <app-radio
                      v-for="item in genders_options"
                      :key="item.code"
                      v-model.number="guestForm.gender"
                      :value="item.code"
                      name="gender"
                      :checked="guestForm.gender"
                      class="family"
                    >
                      <template #label>{{ item.name }}</template>
                    </app-radio>
                  </app-cells>
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Date of birth">
                  <app-date-picker
                    v-model="guestForm.dob"
                    class="family"
                    placeholder="Date of birth"
                  />
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Citizenship">
                  <app-select
                    v-model="guestForm.citizenship"
                    :reduce="item => item.code"
                    :options="countries_options"
                    placeholder="Citizenship"
                    class="family"
                  />
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Passport №" label-for="passport">
                  <app-input
                    v-model="guestForm.passport"
                    id="passport"
                    placeholder="Passport №"
                    class="family"
                  />
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Email" label-for="email">
                  <app-input
                    v-model="guestForm.email"
                    :error="$v.guestForm.email.$error"
                    id="email"
                    type="email"
                    placeholder="Email"
                    class="family"
                  />
                  <template #error>
                    <div v-if="$v.guestForm.email.$dirty && !$v.guestForm.email.email">Enter the correct e-mail format</div>
                  </template>
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Phone">
                  <app-phone
                    v-model="guestForm.phone"
                    placeholder="+255 786 350 350"
                    class="family"
                    :error="$v.guestForm.phone.$dirty && guestForm.phone === 0"
                  />
                  <template #error>
                    <div v-if="$v.guestForm.phone.$dirty && guestForm.phone === 0">Invalid phone number format</div>
                  </template>
                </app-form-field>
              </template>
              <template #item-2>
                <app-form-field :marginBottom="20" class="family" label="Food Preferences">
                  <app-select
                    v-model="guestForm.food_preference"
                    :reduce="item => item.id"
                    :options="food_preference_options"
                    placeholder="Food Preferences"
                    class="family"
                  />
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Restrictions">
                  <app-cells :indent="false" style="height: 38px" gap="10px 15px">
                    <app-checkbox
                      v-model="guestForm.food_gluten_free"
                      label="Gluten Free"
                      class="family"
                    />
                    <app-checkbox
                      v-model="guestForm.food_lactose_free"
                      label="Lactose Free"
                      class="family"
                    />
                    <app-checkbox
                      v-model="guestForm.food_halal"
                      label="Halal"
                      class="family"
                    />
                  </app-cells>
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Allergies" label-for="food_allergy">
                  <app-textarea
                    v-model="guestForm.food_allergy"
                    id="food_allergy"
                    placeholder="Allergies"
                    class="family"
                  />
                </app-form-field>
              </template>
            </app-grid>
            <app-cells :indent="false" position="center">
              <HMButton :loading="isSubmittingGuestForm">
                <span>Save</span>
              </HMButton>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      :adaptive="true"
      :clickToClose="false"
      :height="'auto'"
      :reset="true"
      :scrollable="true"
      :width="700"
      name="edit-details"
    >
      <div class="popup-new">
        <button class="popup-new__close" type="button" @click="$modal.hide('edit-details')"></button>
        <div class="popup-new__title">Edit Reservation</div>
        <div class="popup-new__body">
          <form @submit.prevent="onCheckForm('editDetailsForm', 'onSaveDetails')">
            <app-grid>
              <template #item-1>
                <app-form-field :marginBottom="20" class="family" label="Group name" label-for="group_name" required>
                  <app-input
                    id="group_name"
                    v-model="editDetailsForm.group_name"
                    :error="$v.editDetailsForm.group_name.$error"
                    class="family"
                    placeholder="Group name"
                  />
                  <template #error>
                    <div v-if="$v.editDetailsForm.group_name.$dirty && !$v.editDetailsForm.group_name.required">Required
                      field
                    </div>
                  </template>
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Source" required>
                  <app-select
                    v-model="editDetailsForm.source"
                    :clearable="false"
                    :error="$v.editDetailsForm.source.$error"
                    :options="source_options"
                    :reduce="item => item.id"
                    class="family"
                    placeholder="Choose source"
                  />
                  <template #error>
                    <div v-if="$v.editDetailsForm.source.$dirty && !$v.editDetailsForm.source.required">Required field
                    </div>
                  </template>
                </app-form-field>
                <app-form-field v-if="rData.status.deadline" :marginBottom="20" class="family" label="Deadline">
                  <app-date-picker
                    v-model="editDetailsForm.deadline"
                    class="family"
                    placeholder="Deadline"
                  />
                  <template #error>
                    <div v-if="$v.editDetailsForm.deadline.$dirty && !$v.editDetailsForm.deadline.required">Required
                      field
                    </div>
                  </template>
                </app-form-field>
              </template>
              <template #item-2>
                <app-form-field :marginBottom="20" class="family" label="Meal plan" required>
                  <app-select
                    v-model="editDetailsForm.meal_plan"
                    :clearable="false"
                    :error="$v.editDetailsForm.meal_plan.$error"
                    :options="meal_plan_type_options"
                    :reduce="item => item.code"
                    class="family"
                    placeholder="Choose meal plan"
                  />
                  <template #error>
                    <div v-if="$v.editDetailsForm.meal_plan.$dirty && !$v.editDetailsForm.meal_plan.required">Required
                      field
                    </div>
                  </template>
                </app-form-field>
                <app-form-field :marginBottom="20" class="family" label="Source Reservation ID" label-for="external_id">
                  <app-input
                    id="external_id"
                    v-model="editDetailsForm.external_id"
                    class="family"
                    placeholder="Source Reservation ID"
                  />
                </app-form-field>
              </template>
            </app-grid>
            <app-form-field :marginBottom="20" class="family" label="Notes" label-for="notes">
              <app-textarea
                id="notes"
                v-model="editDetailsForm.notes"
                class="family"
                placeholder="Notes"
              />
            </app-form-field>
            <app-cells :indent="false" position="center">
              <HMButton :loading="isSubmittingEditDetailsForm">
                <span>Save</span>
              </HMButton>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <EditRoomsSummaryModal
      @update-data="$emit('update-data')"
      :show-modal.sync="isShowEditRooms"
      :res-data="rData"
    />
  </div>
</template>

<script>
import HMGuestsTable from '@/views/hotel-management/reservations/components/HMGuestsTable.vue'
import HMRoomsList from '@/views/hotel-management/reservations/components/HMRoomsList.vue'
import HMRoomSummary from '@/views/hotel-management/reservations/components/HMRoomSummary.vue'
import HMDetail from '@/views/hotel-management/reservations/components/HMDetail.vue'
import HMButton from '@/views/hotel-management/reservations/components/HMButton.vue'
import HMInfo from '@/views/hotel-management/reservations/components/HMInfo.vue'
import PenIcon from '@/views/hotel-management/reservations/detail/icons/PenIcon.vue'
import PlusIcon from '@/views/hotel-management/reservations/detail/icons/PlusIcon.vue'

import {
  getCountries,
  getFoodPreferences,
  getGenders,
  getHotelManagementGuests,
  getHotelManagementMealPlanTypes,
  getHotelManagementReservationsRooms,
  getHotelManagementRoomCategories,
  getHotelManagementSources,
  patchHotelManagementReservationV2,
  postHotelManagementGuestsV2,
  postHotelManagementGuestsToReservationV2,
  deleteHotelManagementGuestsFromReservationV2,
  patchHotelManagementGuestsV2
} from '@/http'
import { email, required, requiredIf } from 'vuelidate/lib/validators'
import EditRoomsSummaryModal from '@/views/hotel-management/reservations/components/EditRoomsSummaryModal.vue'

export default {
  name: 'HotelManagementReservationsReservation',
  components: {
    EditRoomsSummaryModal,
    HMButton,
    HMInfo,
    HMRoomsList,
    HMGuestsTable,
    HMRoomSummary,
    HMDetail,
    PlusIcon,
    PenIcon
  },
  props: {
    rData: {type: Object, required: true}
  },
  data() {
    return {
      rooms: [],
      roomsLoading: true,
      guests: [],
      guestsLoading: true,
      openGuestMenuId: null,
      editDetailsForm: {},
      guestForm: {},
      room_type_groups: [],
      source_options: [],
      meal_plan_type_options: [],
      genders_options: [],
      countries_options: [],
      food_preference_options: [],
      isSubmittingEditDetailsForm: false,
      isSubmittingGuestForm: false,
      isDeletingGuest: false,
      guestToAction: null,
      isShowEditRooms: false,
    }
  },
  validations: {
    editDetailsForm: {
      source: {required},
      group_name: {required},
      meal_plan: {required},
      deadline: {
        required: requiredIf(function () {
          return this.rData.status.deadline
        })
      },
    },
    guestForm: {
      first_name: {required},
      last_name: {required},
      email: {email},
      phone: {},
    }
  },
  computed: {
    isHotelReception() {
      return this.$store.state.userGroups.map(item => item.code).includes('hotel_reception')
    },
    isGeneralManager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    isHotelReservations() {
      return this.$store.state.userGroups.map(item => item.code).includes('hotel_reservations')
    },
    isEditDisabled() {
      return this.rData.reservation_hotel !== null
    }
  },
  created() {
    this.fetchRooms()
    this.fetchGuests()
  },
  methods: {
    fetchRooms() {
      getHotelManagementReservationsRooms({reservation: this.$route.params.id})
        .then(res => { this.rooms = res.data })
        .finally(() => { this.roomsLoading = false })
    },
    fetchGuests() {
      getHotelManagementGuests({reservations__id: this.$route.params.id})
        .then(res => {
          this.guests = res.data
        })
        .finally(() => {
          this.guestsLoading = false
        })
    },
    onCheckForm(form, action) {
      this.$v[form].$touch()
      if (this.$v[form].$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this[action]()
      }
    },
    onSaveGuests() {
      this.isSubmittingGuestForm = true
      if (this.guestToAction) {
        patchHotelManagementGuestsV2(this.guestToAction, this.guestForm)
          .finally(() => { this.isSubmittingGuestForm = false })
          .then(() => {
            this.fetchGuests()
            this.$modal.hide('guest-form')
          })
      } else {
        postHotelManagementGuestsV2({...this.guestForm, property: this.rData.property.code})
          .then(res => {
            postHotelManagementGuestsToReservationV2(this.$route.params.id, res.data.id)
              .finally(() => { this.isSubmittingGuestForm = false })
              .then(() => {
                this.fetchGuests()
                this.$modal.hide('guest-form')
              })
          })
      }
    },
    onSaveDetails() {
      this.isSubmittingEditDetailsForm = true
      patchHotelManagementReservationV2(this.$route.params.id, this.editDetailsForm)
        .finally(() => {
          this.isSubmittingEditDetailsForm = false
        })
        .then(() => {
          this.$modal.hide('edit-details')
          this.$emit('update-data')
        })
    },
    onShowModalGuests(guest) {
      Promise.all([getGenders(), getCountries(), getFoodPreferences()])
        .then(res => {
          this.genders_options = res[0].data
          this.countries_options = res[1].data
          this.food_preference_options = res[2].data
          this.guestToAction = guest?.id
          if (guest) {
            this.guestForm = {
              first_name: guest.first_name,
              last_name: guest.last_name,
              gender: guest.gender?.code,
              phone: guest.phone,
              email: guest.email,
              passport: guest.passport,
              citizenship: guest.citizenship?.code,
              dob: guest.dob,
              food_allergy: guest.food_allergy,
              food_lactose_free: guest.food_lactose_free,
              food_gluten_free: guest.food_gluten_free,
              food_preference: guest.food_preference?.id,
            }
          } else {
            this.guestForm = {}
          }
          this.$v.guestForm.$reset()
          this.$modal.show('guest-form')
        })
    },
    onShowDeleteGuestModal(gId) {
      this.guestToAction = gId
      this.$modal.show('guest-delete')
    },
    onDeleteGuest() {
      this.isDeletingGuest = true
      deleteHotelManagementGuestsFromReservationV2(this.$route.params.id, this.guestToAction)
        .finally(() => {
          this.isDeletingGuest = false
        })
        .then(() => {
          this.fetchGuests()
          this.$modal.hide('guest-delete')
        })
    },
    onShowModalEditDetails() {
      Promise.all([getHotelManagementSources({property: this.rData.property.code}), getHotelManagementMealPlanTypes()])
        .then(res => {
          this.source_options = res[0].data
          this.meal_plan_type_options = res[1].data
          this.editDetailsForm = {
            meal_plan: this.rData.meal_plan.code,
            source: this.rData.source.id,
            external_id: this.rData.external_id,
            group_name: this.rData.group_name,
            notes: this.rData.notes,
          }
          if (this.rData.status.deadline) this.editDetailsForm.deadline = this.rData.deadline?.date || ''
          this.$modal.show('edit-details')
        })
    }
  }
}
</script>

<style scoped>
.hm-subt {
  color: #000;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 17px;
  font-weight: 600;
}
</style>
